<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <template slot="header">
          <div class="nav-wrapper">
            <ul role="tablist" class="nav nav-pills nav-pills-circle">
              <li
                v-for="item in tabs"
                :key="item.name"
                class="nav-item col-sm row justify-content-md-center mb-0 flex-direction"
                @click="activateTab(item)"
              >
                <a
                  :class="{ active: item.name === tabName }"
                  href="javascript:;"
                  class="nav-link"
                >
                  <div>
                    <span class="nav-link-icon d-block">
                      <i :class="item.icon" />
                    </span>
                  </div>
                </a>
                <div class="mt-2">{{ item.title }}</div>
              </li>
            </ul>
          </div>
        </template>

        <div v-for="item in getCont()" :key="item.name" class="row">
          <div
            v-for="citem in item.children"
            :key="citem.name"
            class="mb-4 col-md-4"
          >
            <card shadow no-body>
              <div class="text-center pt-5">
                <img
                  :src="citem.logo"
                  :alt="citem.name"
                  class="img-fluid mb-3"
                  style="height: 80px"
                >
                <h5 class="display-4">{{ citem.name }}</h5>
                <p class="card-text small text-muted">
                  版本：{{ citem.version }}
                </p>
                <p class="card-text" />
              </div>
              <div class="pl-4 pr-4 pb-4 pt-2">
                <router-link :to="{ name: citem.tutorial }">
                  <base-button class="mb-3" block type="info">教程</base-button>
                </router-link>
                <a
                  :href="
                    item.name === 'ios'
                      ? `/tutorials/ios/${citem.tutorial}`
                      : citem.download
                  "
                  target="_blank"
                >
                  <base-button block type="success">下载</base-button>
                </a>
              </div>
            </card>
          </div>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      tabName: 'android',
      tabs: [
        {
          name: 'android',
          title: '安卓手机',
          icon: 'fab fa-android'
        },
        {
          name: 'ios',
          title: '苹果手机',
          icon: 'fab fa-apple'
        },
        {
          name: 'win',
          title: 'windows 电脑',
          icon: 'fab fa-windows'
        },
        {
          name: 'macos',
          title: '苹果电脑',
          icon: 'fas fa-laptop'
        }
      ],
      tabContents: [
        {
          name: 'android',
          children: [
            // {
            //   logo: '/img/client/android/bifrostv.png',
            //   name: 'BifrostV',
            //   version: '0.6.7',
            //   tutorial: 'bifrostv',
            //   download:
            //     'https://play.google.com/store/apps/details?id=com.github.dawndiy.bifrostv'
            // },
            {
              logo: '/img/client/android/cmfa.webp',
              name: 'Clash Meta for Android',
              version: '2.10.1',
              tutorial: 'cmfa',
              download:
                'https://mirror.ghproxy.com/https://github.com/MetaCubeX/ClashMetaForAndroid/releases/download/v2.10.0/cmfa-2.10.0-meta-arm64-v8a-release.apk'
            },
            {
              logo: '/img/client/android/nekobox.webp',
              name: 'NekoBox for Android',
              version: '1.2.9',
              tutorial: 'nekobox',
              download:
                'https://ghproxy.com/https://github.com/MatsuriDayo/NekoBoxForAndroid/releases/download/1.2.9/NB4A-1.2.9-arm64-v8a.apk'
            }
            // {
            //   logo: '/img/client/android/v2rayng.png',
            //   name: 'v2rayNG(不推荐)',
            //   version: '1.8.5',
            //   tutorial: 'v2rayng',
            //   download:
            //     'https://www.91freedom.live/img/client/android/v2rayNG_1.8.9.apk'
            // }
          ]
        },
        {
          name: 'ios',
          children: [
            {
              logo: '/img/client/ios/sing-box.webp',
              name: 'Sing-Box(免费)客户端(推荐)',
              version: '1.8.10',
              tutorial: 'sing-box',
              download:
                'https://apps.apple.com/us/app/sing-box/id6451272673'
            },
            {
              logo: '/img/client/ios/shadowrocket.jpg',
              name: 'ShadowRocket',
              version: '2.1.52',
              tutorial: 'shadowrocket',
              download: 'https://apps.apple.com/us/app/shadowrocket/id932747118'
            },
            {
              logo: '/img/client/ios/quantumult.jpg',
              name: 'Quantumult',
              version: '2.2.13',
              tutorial: 'quantumult',
              download: 'https://sstz.me/apple-client/quantumult/index.html'
            }
            // {
            //   logo: '/img/client/ios/kitsunebi.jpg',
            //   name: 'Kitsunebi',
            //   version: '2.3.0',
            //   tutorial: 'kitsunebi',
            //   download:
            //     'https://itunes.apple.com/us/app/kitsunebi-proxy-utility/id1446584073?mt=8'
            // }
          ]
        },
        {
          name: 'win',
          children: [
            {
              logo: '/img/client/macos/logo.png',
              name: 'Clash Verge（推荐）',
              version: '1.5.11',
              tutorial: 'clash-verge',
              download:
                'https://staticn.oss-cn-beijing.aliyuncs.com/clash-verge/1.5.11/Clash.Verge_1.5.11_x64-setup.exe'
            },
            {
              logo: '/img/client/win/v2rayn.png',
              name: 'V2RayN',
              version: '6.39',
              tutorial: 'v2rayn',
              download: 'https://staticn.oss-cn-beijing.aliyuncs.com/v2rayn/6.39/v2rayN.zip'
            }
            // {
            //   logo: '/img/client/win/clash.png',
            //   name: 'Clash',
            //   version: '0.19.21',
            //   tutorial: 'clash',
            //   download:
            //     'https://staticn.oss-cn-beijing.aliyuncs.com/clashwin/0.19.21/Clash.for.Windows.Setup.0.19.21.exe'
            // }
          ]
        },
        {
          name: 'macos',
          children: [
            {
              logo: '/img/client/macos/logo.png',
              name: 'Clash Verge（推荐）',
              version: '1.5.11',
              tutorial: 'clash-verge',
              download:
                '/tutorials/win/clash-verge'
            }
          ]
        }
      ]
    }
  },
  methods: {
    activateTab(item) {
      this.tabName = item.name
    },
    getCont() {
      return this.tabContents.filter((item) => {
        return this.tabName === item.name
      })
    }
  }
}
</script>
<style>
.flex-direction {
  flex-direction: column;
  align-items: center;
}
</style>
